document.addEventListener('DOMContentLoaded', () => {
  const swipers = []
  const nav = () => {
    const $links = document.querySelectorAll('[data-faq-link]')
    const faqSections = document.querySelectorAll('[data-faq-section]')

    if (!$links.length > 0) return

    const activeClass = 'faqs-with-nav__nav-link--active'
    let mm = gsap.matchMedia()  
    const clearActiveLink = () => {
      $links.forEach(link => link.classList.remove(activeClass))
      faqSections.forEach(section => section.classList.remove('active'))
    }

    mm.add('(max-width: 991px)', () => {
      faqSections.forEach((section, i) => {
        const tl = gsap.timeline({
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top top+=180px',
            onEnter: () => {
              clearActiveLink()
              $links[i]?.classList.add(activeClass)
              faqSections[i]?.classList.add('active')
              if (swipers.length) {
                swipers[0].slideTo(i)
              }
            }
          }
        })
      })
      faqSections.forEach((section, i) => {
        const tl = gsap.timeline({
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top top+=170px',
            onLeaveBack: () => {
              clearActiveLink()
              const targetIndex = i === 0 ? 0 : (i -1)
              $links[i]?.classList.add(activeClass)
              faqSections[i]?.classList.add('active')
              if (swipers.length) {
                swipers[0].slideTo(targetIndex)
              }
            }
          }
        })
      })
    })

    mm.add('(min-width: 992px)', () => {
      faqSections.forEach((section, i) => {
        const tl = gsap.timeline({
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top top+=180',
            onEnter: () => {
              clearActiveLink()
              $links[i]?.classList.add(activeClass)
              faqSections[i]?.classList.add('active')
            }
          }
        })
      })

      faqSections.forEach((section, i) => {
        const tl = gsap.timeline({
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top top+=150',
            onLeaveBack: () => {
              clearActiveLink()
              $links[i]?.classList.add(activeClass)
              faqSections[i]?.classList.add('active')
            }
          }
        })
      })
    })
  }

  const sliders = () => {
    const $sliders = document.querySelectorAll('[data-faq-nav-swiper]')

    if (!$sliders.length > 0) return

    $sliders.forEach((slider, i) => {
      const buildSlider = () => {
        swipers[i] = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          breakpoints: {
            992: {
              spaceBetween: 0,
            },
          }
        })
        swipers[0].on('afterInit', () => {
          console.log('inited')
          window.triggerRefresh()
        })
      }

      const breakpoint = window.matchMedia('(max-width: 991px)')

      const startSliders = () => {
        if (breakpoint.matches) {
          if (swipers.length) return

          buildSlider()
        } else {
          if (swipers[i]) {
            swipers[i].destroy(true, true)
            swipers = []
          }
        }
      }

      startSliders()

      breakpoint.addEventListener('change', startSliders)
    })
  }

  nav()
  sliders()
})